import { useTranslation } from 'react-i18next';
import { Tabs } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { ListWithPagination } from '@anytag/shared-molecules';
import { TiktokTagsAnalyticsSearchSchemaType, useTiktokTagsAnalyticsFilter } from '@anytag/shared-organisms';

interface TiktokTagsAnalyticsTemplateProps {
  children: React.ReactNode;
}

export const TiktokTagsAnalyticsTemplate = ({ children }: TiktokTagsAnalyticsTemplateProps) => {
  const { t } = useTranslation();
  const { filter, countryId } = useTiktokTagsAnalyticsFilter();

  const tabSearch = { filter: { ...filter, tagId: '' } } satisfies Pick<TiktokTagsAnalyticsSearchSchemaType, 'filter'>;

  return (
    <ListWithPagination css={{ backgroundColor: THEME.background.colors.white }}>
      <div css={{ display: 'flex', gap: '4px', padding: '21px 24px', boxSizing: 'border-box' }}>
        <div css={{ flex: 1 }}>
          <p css={{ fontSize: '18px', fontWeight: 600, lineHeight: '100%' }}>
            {t('TikTok Hashtag & Keyword analysis')}
          </p>
          <p css={{ fontSize: '14px', marginTop: '8px', lineHeight: '100%', color: THEME.text.colors.gray.lv3 }}>
            {t('Analyze TikTok hashtags & Keywords')}
          </p>
        </div>
      </div>

      <Tabs
        className="rounded-t-none border-t border-b-0"
        options={[
          {
            end: false,
            search: tabSearch,
            label: t('Hashtag'),
            params: { countryId: countryId.toLowerCase() },
            to:
              countryId && countryId !== 'JP'
                ? '/hashtag-analytics/tiktok/hashtag/$countryId'
                : '/hashtag-analytics/tiktok/hashtag'
          },
          {
            end: false,
            search: tabSearch,
            label: t('Keyword'),
            params: { countryId: countryId.toLowerCase() },
            to:
              countryId && countryId !== 'JP'
                ? '/hashtag-analytics/tiktok/keyword/$countryId'
                : '/hashtag-analytics/tiktok/keyword'
          }
        ]}
      />

      {children}
    </ListWithPagination>
  );
};
